import { render, staticRenderFns } from "./CopyCategoryCollapse.vue?vue&type=template&id=1b5adac8&scoped=true"
import script from "./CopyCategoryCollapse.vue?vue&type=script&lang=js"
export * from "./CopyCategoryCollapse.vue?vue&type=script&lang=js"
import style0 from "./CopyCategoryCollapse.vue?vue&type=style&index=0&id=1b5adac8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5adac8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b5adac8')) {
      api.createRecord('1b5adac8', component.options)
    } else {
      api.reload('1b5adac8', component.options)
    }
    module.hot.accept("./CopyCategoryCollapse.vue?vue&type=template&id=1b5adac8&scoped=true", function () {
      api.rerender('1b5adac8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/configuration/components/configurationCopy/modais/CopyCategoryCollapse.vue"
export default component.exports